export default __webpack_public_path__ + "static/media/my_resume.6c197c65.pdf";